import whatsapp_icon from "../../Img/Android_Enterprise_image/whatsapp_icon.png";
import mail_icon from "../../Img/Android_Enterprise_image/mail_icon.png";
import industry_1 from "../../Img/Mobile_Device_Management_image/industry_1.svg";
import industry_2 from "../../Img/Mobile_Device_Management_image/industry_2.svg";
import industry_3 from "../../Img/Mobile_Device_Management_image/industry_3.svg";
import industry_4 from "../../Img/Mobile_Device_Management_image/industry_4.svg";
import section_img_1 from "../../Img/Mobile_Device_Management_image/section_img_1.jpg";
import number_1 from "../../Img/Mobile_Device_Management_image/number_1.png";
import number_2 from "../../Img/Mobile_Device_Management_image/number_2.png";
import number_3 from "../../Img/Mobile_Device_Management_image/number_3.png";
import Navbar from "../../Components/Navbar/Navbar";
import Footer from "../../Components/Footer/Footer";
const Enterprise_Finance = () => {
  return (
    <>
      <Navbar></Navbar>
      <section class="banner_section elementor-column-gap-extended">
        <div class="container">
          <h1 class="elementor-heading-title">Enterprise IT Financing</h1>
          <div class="dropdown-str mt-4">
            <a class="dropbtn-str" href="/ContactUs" target="_blank">
              Contact Us
            </a>
          </div>
        </div>
      </section>
      {/* --------------------------------------------------- */}
      <section class="mt-5">
        <div class="container">
          <div class="row g-4">
            <div class="col-12">
              <div class="best-in-class">
                <h1>
                  Empowering your digital transformation through robust IT
                  financing options
                </h1>
                <p class="mt-2">
                  Unlock your business's full potential with flexible and
                  scalable IT financing solutions. Whether upgrading
                  infrastructure, adopting new technologies, or expanding
                  operations, our financing options help reduce upfront costs,
                  improve cash flow, and drive innovation—empowering you to stay
                  ahead in the fast-evolving digital landscape.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ------------------------------------------------------- */}

      <section class="py-5 text-center mt-4">
        <div class="container">
          <h2 class="section-title pb-3">Industry Pain Points</h2>
          <p>
            If you are facing these problems, then it’s time to revamp your
            collaboration and connectivity infrastructure.
          </p>
          <div class="row mt-5">
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_1} alt="" className="img-fliud" />
                <p>
                  Challenges in scaling device deployment across distributed
                  teams.
                  <br />
                  Zero-touch enrollment simplifies setup, ensuring seamless
                  device integration for remote and on-site teams.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_2} alt="" className="img-fliud" />
                <p>
                  High operational costs due to manual device setup and
                  management.
                  <br />
                  Automating device enrollment with Zerotouch reduces IT
                  workload and lowers long-term expenses.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_3} alt="" className="img-fliud" />
                <p>
                  Difficulty in accessing cost-effective device deployment for
                  zero-touch enrollment.
                </p>
              </div>
            </div>
            <div class="col-12 col-sm-6 col-lg-3 mb-4">
              <div class="feature-card p-4">
                <img src={industry_4} alt="" className="img-fliud" />
                <p>
                  Inconsistent connectivity and support for devices across the
                  organization.
                  <br />
                  Zerotouch ensures reliable, automated connectivity with 24/7
                  support for all enrolled devices.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* -------------------------------------------------------------- */}
      <section class="custom-section">
        <div class="container">
          <div class="row align-items-center g-4">
            {/* -- Text -- */}
            <div class="col-lg-6">
              <p class="highlight">How Harsafe can help​</p>
              <h2 class="main-title">
                Flexibility, technology, and convenience
              </h2>
              <p class="description">
                Blending technology with our expertise, Harsafe offers an array
                of IT financing and asset management solutions that allow
                flexibility and convenience. From monthly expense management,
                budget alignments, and deployments, we will ensure you have the
                latest tech you need to reduce risk, optimize costs, and improve
                efficiency. Our bouquet of offerings like leasing, renting and
                exchange is powered by hassle-free policies to ensure your
                organization’s success.
              </p>
            </div>
            {/* -- Image -- */}
            <div class="col-lg-6 position-relative">
              <div class="image-box">
                <img src={section_img_1} alt="" className="img-fliud" />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ----------------------------------------- */}
      <section class="why-section mt-4">
        <div class="container">
          <h2 class="why-title">Our Process</h2>
          <div class="row why-overlay mx-auto mt-5 g-4">
            <div class="col-md-4 col-sm-6 mb-4 why-card">
              <div class="Our_Process">
                <div class="why-icon">
                  <img src={number_1} alt="" className="img-fliud" />
                </div>
                <h5>Discover and Analyze</h5>
                <p>
                  Identify various areas of improvement and pain points to
                  understand how we can help you.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-4 why-card">
              <div class="Our_Process">
                <div class="why-icon">
                  <img src={number_2} alt="" className="img-fliud" />
                </div>
                <h5>Model</h5>
                <p>
                  Strategize tools and resources from the right partners to give
                  you a model that is cost-effective and effecient.
                </p>
              </div>
            </div>
            <div class="col-md-4 col-sm-6 mb-4 why-card">
              <div class="why-icon">
                <img src={number_3} alt="" className="img-fliud" />
              </div>
              <h5>Execute and Deliver</h5>
              <p>
                Deliver and train your IT and support team to sustain. Also
                adjust the processes to improve business objective.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer></Footer>
    </>
  );
};

export default Enterprise_Finance;
